export default __webpack_public_path__ + "static/media/111.9474be73.jpg";